export default 'firetv';
